import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import { Select } from "antd";
import { Modal, Spinner } from "react-bootstrap";
import { getParentChildFacility, addComments } from "./actions";
import Maintenance from "../Maintenance";

function ParentChildChange() {
  const [show, setShow] = useState(false);
  const [lang] = useTranslation("language");
  const [role, setRole] = useState("");
  const [filter, setFilter] = useState("under_review");
  const [successShow, setSuccessShow] = useState(false);
  const [failureShow, setFailureShow] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState("");
  const [modalComment, setModalComment] = useState("");
  const [maintenance, setMaintenance] = useState(false);
  const [comment, setComment] = useState("");
  const [allChecked, setAllChecked] = useState(false);
  const [facilityList, setFacilityList] = useState([]);

  const [sortChildCustomerCode, setSortChildCustomerCode] = useState("asc");
  const [sortMarketAuthCode, setSortMarketAuthCode] = useState("asc");
  const [sortCustomerCode, setSortCustomerCode] = useState("asc");
  const [sortID,setSortID] = useState("asc");
  const [sortCurrentCustomerCode, setSortCurrentCustomerCode] = useState("asc");
  const [sortWorkflowState, setSortWorkflowState] = useState("asc");
  const [sortSubmittedBy, setSortSubmittedBy] = useState("asc");
  const [sortSubmittedAt, setSortSubmittedAt] = useState("asc");
  const [sortReviewedBy, setSortReviewedBy] = useState("asc");
  const [sortReviewedAt, setSortReviewedAt] = useState("asc");
  const canReviewAction = filter === "under_review";

  const redirect = "/parentChildChange";
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.parentChildChange")}`,
      path: "",
    },
  ];

  const options = [
    { value: "under_review", label: "Under review" },
    { value: "last_10_days", label: "Submitted within 10 days" },
    { value: "last_30_days", label: "Submitted within 30 days" },
    { value: "last_90_days", label: "Submitted within 90 days" },
  ];

  useEffect(() => {
    const role = sessionStorage.getItem("User role");
    sessionStorage.setItem("return_url", "/parentChildChange");
    setRole(role);
    if (sessionStorage.getItem("token")) {
      getParentChildFacilityList("under_review");
      sessionStorage.setItem("return_url", "");
    }
  }, []);

  /*** 
    @purpose : Get parent child facility list
    @Parameter : {}
    **/
  const getParentChildFacilityList = async (value) => {
    setLoading(true);
    setNoData(false);
    setFacilityList([]);
    let body = {
      filter: value,
      limit: 0,
    };
    await getParentChildFacility(body).then((response) => {
      if (response.maintenanceWindowFlag) {
        setMaintenance(true);
      } else {
        if (response.success === true && response.data !== null) {
          var result =
            response &&
            response.data.map(function (el) {
              var o = Object.assign({}, el);
              o.isChecked = false;
              return o;
            });
          setLoading(false);
          setFacilityList(result);
          setTotal(response && response.total);
          setNoData(false);
        }
        if (
          (response.success === true && response.data.length === 0) ||
          response.success === false
        ) {
          setLoading(false);
          setNoData(true);
          setFacilityList([]);
        }
      }
    });
  };

  /*** 
    @purpose : Handle filter
    @Parameter : {}
    **/
  const handleFilter = async (value) => {
    setFilter(value.value);
    setAllChecked(false);
    getParentChildFacilityList(value.value);
  };

  /*** 
    @purpose : Close modal
    @Parameter : {}
    **/
  const handleClose = () => setShow(false);

  /*** 
    @purpose : Close success modal
    @Parameter : {}
    **/
  const handleSuccessClose = () => setSuccessShow(false);

  /*** 
    @purpose : Close failure modal
    @Parameter : {}
    **/
  const handleFailureClose = () => setFailureShow(false);

  /*** 
    @purpose : Show modal
    @Parameter : {}
    **/
  const modalShow = (value) => {
    setModalComment(value);
    setShow(true);
  };

  /*** 
    @purpose : Show modal
    @Parameter : {}
    **/
  const modalSuccessShow = () => {
    setSuccessShow(true);
  };

  /*** 
    @purpose : Handle checkbox
    @Parameter : {e}
    **/
  const handleCheckbox = (e) => {
    let tempListing = [...facilityList];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else if (e.target.value !== "checkAll") {
      setAllChecked(false);
      tempListing.forEach((item) => {
        if (item.ID == e.target.value) {
          item.isChecked = e.target.checked;
          checkedAll = false;
        }
      });
    }
    setFacilityList(tempListing);
    setAllChecked(checkedAll);
  };

  /*** 
    @purpose : Handle comment action
    @Parameter : {}
    **/
  const handleCommentAction = async (value) => {
    const list = facilityList
      .filter((fac) => fac.isChecked === true)
      .map((fac) => fac.ID);
    if (list.length === 0) {
      return;
    }
    setCommentLoading(true);
    let body = {
      action: value,
      remarks: comment,
      id: list,
    };
    await addComments(body).then((response) => {
      setCommentLoading(false);
      setComment("");
      getParentChildFacilityList(filter);
      if (response.success === true) {
        setSuccessShow(true);
      } else {
        setFailureShow(true);
      }
    });
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {obj}
  **/
  const handleSortingData = (obj) => {
    obj.column === "childCustomerCode" &&
      setSortChildCustomerCode(obj.sortOrder);
    obj.column === "marketAuthourizationNameAbbr" &&
      setSortMarketAuthCode(obj.sortOrder);
    obj.column === "customerCode" && setSortCustomerCode(obj.sortOrder);
    obj.column === "currentCustomerCode" &&
      setSortCurrentCustomerCode(obj.sortOrder);
    obj.column === "workflowState" && setSortWorkflowState(obj.sortOrder);
    obj.column === "submittedBy" && setSortSubmittedBy(obj.sortOrder);
    obj.column === "submittedAt" && setSortSubmittedAt(obj.sortOrder);
    obj.column === "reviewedBy" && setSortReviewedBy(obj.sortOrder);
    obj.column === "reviewedAt" && setSortReviewedAt(obj.sortOrder);
    obj.column === "ID" && setSortID(obj.sortOrder);
    let list = compareBySortedData(obj);
    setFacilityList(list);
  };

  /*** 
  @purpose : Compare sorted data
  @Parameter : {obj}
  **/
  const compareBySortedData = (obj) => {
    const sorted = facilityList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      if (typeof first !== 'string' && !(typeof first === 'number' && isNaN(first))) {
        first = first.toString();
      }
      if (typeof second !== 'string' && !(typeof second === 'number' && isNaN(second))) {
        second = second.toString();
      }
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "parentchild";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return role === "Admin" ||
    role === "SalesManager" ||
    role === "MR" ||
    redirect === "/parentChildChange" ? (
    <Home>
            {maintenance ? (
        <Maintenance />
      ) : (
        <>
      <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
      <h2>{lang("Menu.parentChildChange")}</h2>

      <div className="card">
        <div className="card-header transperent">
          <div className="max-230">
            <Select
              className="ant-select"
              options={options}
              onChange={handleFilter}
              defaultValue={{ value: "under_review", label: "Under review" }}
              labelInValue={true}
              showSearch
              optionFilterProp="label"
            />
          </div>
        </div>
        <div className="card-body">
          {facilityList && facilityList.length !== 0 && (
            <>
              <p className="record-total">
                {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                {facilityList.length} / {total}
              </p>
              <div className="table-responsive max-height-lg">
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      {(role === "Admin" || role === "SalesManager") && (
                        <th>
                          {canReviewAction && (
                            <div className="custom-checkbox d-inline-block">
                              <input
                                type="checkbox"
                                id="tc1"
                                value="checkAll"
                                name="checkAll"
                                checked={allChecked}
                                onChange={(e) => handleCheckbox(e)}
                              />
                              <label htmlFor="tc1"></label>
                            </div>
                          )}
                        </th>
                      )}

                      <th
                          scope="col"
                          onClick={() =>
                              handleSortingData({
                                column: "ID",
                                sortOrder:
                                    sortID === "desc" ? "asc" : "desc",
                              })
                          }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.id")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "childCustomerCode",
                            sortOrder:
                              sortChildCustomerCode === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.childFacility")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "marketAuthourizationNameAbbr",
                            sortOrder:
                              sortMarketAuthCode === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.product")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerCode",
                            sortOrder:
                              sortCustomerCode === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.newParentFacility")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "currentCustomerCode",
                            sortOrder:
                              sortCurrentCustomerCode === "desc"
                                ? "asc"
                                : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang(
                            "parentChildChangeRequest.currentParentFacility"
                          )}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "workflowState",
                            sortOrder:
                              sortWorkflowState === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.status")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.comments")}{" "}
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "submittedBy",
                            sortOrder:
                              sortSubmittedBy === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.submittedBy")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "submittedAt",
                            sortOrder:
                              sortSubmittedAt === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.submittedAt")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "reviewedBy",
                            sortOrder:
                              sortReviewedBy === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.reviewedBy")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "reviewedAt",
                            sortOrder:
                              sortReviewedAt === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildChangeRequest.reviewedAt")}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {facilityList &&
                      facilityList.map((fac, key) => {
                        return (
                          <tr key={key}>
                            {(role === "Admin" || role === "SalesManager") &&
                              fac.workflowState === "under_review" && (
                                <td>
                                  <div className="custom-checkbox d-inline-block">
                                    <input
                                      type="checkbox"
                                      id={fac.ID}
                                      name={fac.ID}
                                      value={fac.ID}
                                      checked={fac.isChecked}
                                      onChange={(e) => handleCheckbox(e)}
                                      key={fac.ID}
                                    />
                                    <label htmlFor={fac.ID}></label>
                                  </div>
                                </td>
                              )}
                            {(role === "Admin" || role === "SalesManager") &&
                              fac.workflowState !== "under_review" && <td></td>}
                            <td>{fac.ID ? fac.ID : ""}</td>
                            <td>
                            {fac.childCustomerCode} : <br />
                              {fac.childCustomerName}
                            </td>
                            <td>{fac.marketAuthourizationNameAbbr}</td>
                            <td>
                              {fac.customerCode ? fac.customerCode : ""} :{" "}
                              <br />
                              {fac.customerName ? fac.customerName : ""}
                            </td>
                            <td>
                              {fac.currentCustomerCode
                                ? fac.currentCustomerCode
                                : ""}{" "}
                              : <br />
                              {fac.currentCustomerName
                                ? fac.currentCustomerName
                                : ""}
                            </td>
                            <td>
                              {fac.workflowState &&
                                fac.workflowState === "under_review" && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => modalShow(fac.comment)}
                                    disabled={true}
                                  >
                                    {lang(
                                      "parentChildFacilityMaintenance.underReview"
                                    )}
                                  </button>
                                )}
                              {fac.workflowState === "approval_accepted" && (
                                <button
                                  className="btn btn-primary"
                                  disabled={true}
                                >
                                  {lang("Buttons.approve")}
                                </button>
                              )}
                              {fac.workflowState === "approval_rejected" && (
                                <button
                                  className="btn btn-danger"
                                  disabled={true}
                                >
                                  {lang("Buttons.reject")}
                                </button>
                              )}
                            </td>
                            <td>
                              {/* {fac.workflowState &&
                                fac.workflowState === "under_review" && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => modalShow(fac.comment)}
                                    disabled={
                                      fac.workflowState === "under_review"
                                    }
                                  >
                                    {lang(
                                      "parentChildFacilityMaintenance.underReview"
                                    )}
                                  </button>
                                )} */}
                              {fac.workflowState === "approval_accepted" && (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => modalShow(fac.comment)}
                                >
                                  View Comments
                                </button>
                              )}
                              {fac.workflowState === "approval_rejected" && (
                                <button
                                  className="btn btn-danger"
                                  onClick={() => modalShow(fac.comment)}
                                >
                                  View Comments
                                </button>
                              )}
                            </td>
                            <td><div><span style={{display : 'block'}}>{fac.submittedByWWID}</span><span>{fac.submittedBy}</span></div></td>
                            <td style={{ whiteSpace: 'nowrap' }}>{fac.submittedAt}</td>
                            <td><div><span style={{display : 'block'}} >{fac.reviewedByWWID}</span><span>{fac.reviewedBy}</span></div></td>
                            <td>{fac.reviewedAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && (
            <div className="noData">{lang("errorMessages.NO_DATA")}</div>
          )}
          {(role === "Admin" || role === "SalesManager") &&
            // || role === "MR"
            facilityList.length !== 0 &&
            canReviewAction && (
              <div className="row mt-5">
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <label>{lang("errorMessages.comment")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </div>
                  <div className="buttons-group action-btn">
                    {commentLoading && <Spinner animation="border" />}
                    <button
                      className="btn btn-primary"
                      onClick={() => handleCommentAction("approve")}
                      disabled={commentLoading}
                    >
                      {lang("Buttons.approve")}
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleCommentAction("reject")}
                      disabled={commentLoading}
                    >
                      {lang("Buttons.reject")}
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>

      <Modal
        size="sm"
        className="comment-modal"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <div>
            <div className="comment-image">
              <img src="images/comment.svg" alt="Comment" />
            </div>
            <h4 className="mb-0">
              {lang("parentChildChangeRequest.comments")}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="warning-msg">{modalComment}</div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleClose}>
              OK
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        className="withdraw-modal"
        show={successShow}
        onHide={handleSuccessClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            {lang("errorMessages.SAVE_SUCCESS")}
          </div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleSuccessClose}>
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        className="withdraw-modal"
        show={failureShow}
        onHide={handleFailureClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
          </div>
          <div className="buttons-group">
            <button className="btn btn-primary" onClick={handleFailureClose}>
              {lang("Buttons.ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
       </>
      )}
    </Home>
  ) : (
    <p>Page Not found</p>
  );
}

export default ParentChildChange;
